import React from 'react';
import { motion } from 'framer-motion';
import { useParams, Link } from 'react-router-dom';
import { CheckCircle2, Download } from 'lucide-react';
export function PaymentSuccessPage() {
  const {
    paymentLinkId
  } = useParams();
  return <div className="min-h-screen bg-background text-textMain flex items-center justify-center p-6" data-id="element-6822">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} className="max-w-md w-full bg-surface border border-border rounded-2xl p-8 text-center" data-id="element-6823">
        <div className="w-16 h-16 rounded-full bg-green-500/20 text-green-500 flex items-center justify-center mx-auto mb-6" data-id="element-6824">
          <CheckCircle2 className="w-8 h-8" data-id="element-6825" />
        </div>
        <h1 className="text-2xl font-bold mb-2" data-id="element-6826">Payment Successful</h1>
        <p className="text-textMuted mb-6" data-id="element-6827">
          Thank you! Your payment of $750.00 has been processed successfully. A
          receipt has been sent to your email.
        </p>

        <div className="bg-background border border-border rounded-xl p-4 mb-8 text-left text-sm" data-id="element-6828">
          <div className="flex justify-between mb-2" data-id="element-6829">
            <span className="text-textMuted" data-id="element-6830">Amount Paid</span>
            <span className="font-medium" data-id="element-6831">$750.00</span>
          </div>
          <div className="flex justify-between mb-2" data-id="element-6832">
            <span className="text-textMuted" data-id="element-6833">Date</span>
            <span className="font-medium" data-id="element-6834">June 1, 2026</span>
          </div>
          <div className="flex justify-between" data-id="element-6835">
            <span className="text-textMuted" data-id="element-6836">Invoice</span>
            <span className="font-medium" data-id="element-6837">INV-2026-041</span>
          </div>
        </div>

        <div className="space-y-4" data-id="element-6838">
          <button className="w-full py-2 bg-surface border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors flex items-center justify-center gap-2" data-id="element-6839">
            <Download className="w-4 h-4" data-id="element-6840" /> Download Receipt
          </button>
          <div className="pt-4 border-t border-border" data-id="element-6841">
            <p className="text-xs text-textMuted" data-id="element-6842">
              Powered by{' '}
              <Link to="/" className="text-primary hover:underline" data-id="element-6843">
                Booker
              </Link>
            </p>
          </div>
        </div>
      </motion.div>
    </div>;
}